var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgColorize = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m34.517 9.383-3.9-3.9a1.66 1.66 0 0 0-2.35 0l-5.2 5.2L19.85 7.5 17.5 9.85l2.367 2.367L5 27.083V35h7.917l14.866-14.867L30.15 22.5l2.35-2.35-3.2-3.2 5.2-5.2a1.665 1.665 0 0 0 .017-2.367zM11.533 31.667l-3.2-3.2 13.434-13.434 3.2 3.2-13.434 13.434z"
})));
export default SvgColorize;